module.exports = __webpack_public_path__ + "static/media/logo.fefa776d.svg";